import api from "../../../../api/axios";

export const getAllSellers = async (params) => {
  try {
     const res = await api.get("/seller", { params });
    return res?.data;
  } catch (err) {
    console.error("getAllSellers error:", err);
    throw err;
  }
};

export const deleteSellerListing = async (id) => {
  try {
    const res = await api.delete(`/seller/${id}`);
    return res?.data;
  } catch (err) {
    console.error("deleteSellerListing error:", err);
    throw err;
  }
};

export const getAllNetFirst = async (params) => {
  try {
     const res = await api.get("/netfirst", { params });
    return res?.data;
  } catch (err) {
    console.error("getAllNetFirst error:", err);
    throw err;
  }
};

export const deleteNetFirstListing = async (id) => {
  try {
    const res = await api.delete(`/netfirst/${id}`);
    return res?.data;
  } catch (err) {
    console.error("deleteNetFirstListing error:", err);
    throw err;
  }
};